import React from 'react';
import styled from '@emotion/styled/macro';
import { LongTextProps } from './long-text.types';
import { PAtom } from '@atoms/text-atoms/text-atoms';

const LongText: React.FC<LongTextProps> = ({ content = '', className }) => {
  if (content && content.length > 0) {
    return (
      <div className={className}>
        {content.split('\n\n').map((paragraph, index) => (
          <PAtom key={`paragraph-${index}`}>{paragraph}</PAtom>
        ))}
      </div>
    );
  } else {
    return null;
  }
};

const StyledLongText = styled(LongText)`
  width: 100%;
`;

export default StyledLongText;
